function setBodyPadding(header, body) {

  const headerHeight = header.offsetHeight
  body.style.paddingTop = `${headerHeight}px`
  console.log(headerHeight)
}

export function fixedNavbar() {
  const body = document.querySelector('body')
  const header = document.querySelector('.header')

  setBodyPadding(header, body)

  window.addEventListener('resize', () => {
    setBodyPadding(header, body)
  })
}
